export const Step2Selectors = {
    // I didn't know how to properly name these Selectors, so I just put "common". By this name I meant
    // the rest of the selectors that couldn't be grouped
    COMMON:               {
        FORM:                                  '#step2_form',
        MODAL_FORM:                            '#step2modalForm',
        GUEST_MODAL:                            '#GuestModal',
        NEW_ACCOUNT_MODAL:                      '#NewAcccountModal',
        BTN_CREATE_NEW_ACCOUNT_AND_CONTINUE: '.btnStep2CreateAccountAndContinue',
        CREDIT_BANK_MODAL:                    '#CreditBankModal',
        MODAL_EMAIL:                           '#step2-modal-email',
        MODAL_FORM_SERIALIZED:                 '#cart-form-serialized',
        CREDIT_PAYMENT_MODAL:					'#CreditPaymentModal',
		    CREDIT_PAYMENT_MODAL_BTN_ACCEPT: 		'.btn-accept-credit-payment-method-full-cost',
        DELIVERY:                              '#delivery',
        DELIVERY_EMAIL_INPUT:                  '#delivery_email',
        PAYMENT:                               '#payment',
        CONTINUE_AS_GUEST_BTN:                 '.continueAsGuest',
        LOGIN_WHEN_USER_IS_GUEST_BTN:          '#login-when-user-is-guest',
        LAST_STEP_BTN:                         '#lastStepButton',
        LAST_STEP_BTN_FINAL:                   '#lastStepButtonFinal',
        ALLOW_GUEST_CHECKER:                   '#allowGuestContinue',
        SAVED_DELIVERY:                        '#cart_saved_delivery',
        WANT_NEW_ACCOUNT_CHECKBOX:             '#want_new_account',
        WANT_INVOICE_CHECKBOX:                 '#want_invoice',
        CREATE_NEW_ACCOUNT_PASSWORD:           '#create_account_repeat_password',
        SECRET_FIELD_NEW_PASSWORD: 				'#newPassword',
        WANT_ANOTHER_DELIVERY_ADRESS_CHECKBOX: '#want_another_delivery_address',
        COPY_INVOICE_BTN:                      '#step2-copy-invoice',
        COPY_ANOTHER_DELIVERY_ADRESSES_BTN:    '#step2-copy-another_delivery',
        INVOICE_DATA:                          '#invoice-data',
        DELIVERY_TILE:                         '.method-delivery',
        DELIVERY_TILE_SALON:                   '#delivery_method_19',
        DELIVERY_TILE_KURIER:                   '#delivery_method_20',
        DELIVERY_TILE_OWN_TRANSPORT:            '#delivery_method_21',
        DELIVERY_TILE_DPD_PACKMACHINE:               '#delivery_method_22',
        DELIVERY_TILE_DPD_POINT:                     '#delivery_method_23',
        // No, these are not new radio stations. They're just an inputs with type radio
        DELIVERY_RADIO:                        '#delivery .delivery_method_radio',
        SELECTED_DELIVERY_RADIO:               '#delivery .delivery_method_radio:checked',
        DELIVERY_RADIO_SALON:                  '#cart_delivery_method_19',
        DELIVERY_RADIO_KURIER:                 '#cart_delivery_method_20',
        DELIVERY_RADIO_OWN_TRANSPORT:           '#cart_delivery_method_21',
        DELIVERY_RADIO_DPD_PACKMACHINE:         '#cart_delivery_method_22',
        DELIVERY_RADIO_DPD_POINT:               '#cart_delivery_method_23',
        SELECTED_PAYMENT_RADIO:					'#payment .payment_method_radio:checked',
        DELIVERY_RADIO_IS_CREDIT:				'payment_method_radio_is_credit',
        PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_3_0_10:	'#cart_payment_method_13',
        PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_0_20:	'#cart_payment_method_12',
        PAYMENT_METHOD_ERATY:                  '#cart_payment_method_10',
        PAYMENT_METHOD_PRZELEWY:               '#cart_payment_method_8',
        PAYMENT_METHOD_COD:                    '#cart_payment_method_6',
        PAYMENT_TILE_COD:                      '#payment_method_6',
        PAYMENT_TILE_ERATY:                    '#payment_method_10',
        PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_3_0_10:	'#payment_method_13',
        PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_0_20:		'#payment_method_12',
        CREDIT_AGRICOLE_CALCULATOR_BTN:			'.js-btn-ca-calculator',
        CREDIT_AGRICOLE_PAYMENT_TEXT_AVAILABLE:		'.js-payment-ca-text-available',
        CREDIT_AGRICOLE_PAYMENT_TEXT_UNAVAILABLE:	'.js-payment-ca-text-unavailable',
        PAYMENT_ERROR_CREDIT_AGRICOLE_MAX_LIMIT:	'.payment_method_error_credit_agricole_max_limit',
        PAYMENT_ERROR_CREDIT_AGRICOLE_INVOICE:		'.payment_method_error_credit_agricole_invoice',
        PAYMENT_INFO_CREDIT_AGRICOLE_WARNING:		'.payment_method_info_credit_agricole_warning',
        PAYMENT_INFO_CREDIT_AGRICOLE_LINK_PDF:		'.payment_method_info_credit_agricole_link_pdf',
        ANOTHER_DELIVERY_ADDRESS_DATA:         '#another-delivery-address-data',
        LIGHT_PRELOADER:                       '#light-preloader',
        SUMMARY_BASKET_PRICE:					'#summary-delivery-price',
        CART_THRESHOLD: {
            INPUT_IS_ACTIVE : '#cartThresholdIsdActive',
            INPUT_IS_FIRST_THRESHOLD_CROSSED : '#cartThresholdIsFirstThresholdIsCrossed'
		    }
    },
    DELIVERY_FORM_FIELDS: {
        CART_SAVED_DELIVERY: '#cart_saved_delivery',
        DELIVERY_FIRST_NAME: '#delivery_first_name',
        DELIVERY_LAST_NAME:  '#delivery_last_name',
        DELIVERY_STREET:     '#delivery_street',
        DELIVERY_HNUMBER:    '#delivery_hnumber',
        DELIVERY_LNUMBER:    '#delivery_lnumber',
        DELIVERY_POSTAL:     '#delivery_postal',
        DELIVERY_CITY:       '#delivery_city',
        DELIVERY_PHONE:      '#delivery_phone',
    },
    FORM_FIELDS_ERROR:    {
        ID_INPUT: '#delivery_department_id-error',
    },
    INVOICE: {
        SECTION: '#invoice-section-data',
        BTN_SEARCH_CONTRACTOR:	'.btn-find-contractor-by-nip',
        FIELD_NIP: '#invoice_nip',
        FIELD_NIP_ERROR: '#invoice_nip_error',
        CONTRACTORS_LIST : {
            SECTION : '#invoice-contractors-list',
            SELECTED_CONTRACTOR_ITEM : '#invoice-contractors-selected-contractor',
            SELECTED_CONTRACTOR_ITEM_BTN : '.btn-invoice-contractors-selected-contractor',
            SELECTED_CONTRACTOR_ITEM_TEXT_FIRST_ROW : '.invoice-contractors-selected-contractor-text-first-row',
            SELECTED_CONTRACTOR_ITEM_TEXT_SECOND_ROW : '.invoice-contractors-selected-contractor-text-second-row',
            TEMPLATE_ELEMENT : '#invoice-contractors-item-template',
            LIST_CONTAINER : '#invoice-contractors-list-container',
            LIST_CONTAINER_SORTABLE_MODE : '.contractors-list-sortable',
            SINGLE_CONTRACTOR_ROW : '.invoice-contractor-item',
            SINGLE_CONTRACTOR_RADIO_BUTTON : '.invoice-contractor-item-btn',
            SINGLE_CONTRACTOR_LABEL : '.invoice-contractor-item-label',
            SINGLE_CONTRACTOR_TEXTS : '.invoice-contractors-item-texts',
            SINGLE_CONTRACTOR_TEXT_FIRST_LINE : '.invoice-contractors-item-text-first-line',
            SINGLE_CONTRACTOR_TEXT_SECOND_LINE : '.invoice-contractors-item-text-second-line',
		    },
        FORM_SECTION : '#invoice-data-fields',
        FORM_FIELDS : {
            INVOICE_COMPANY_NAME: '#invoice_company_name',
            INVOICE_COMPANY_STREET: '#invoice_street',
            INVOICE_COMPANY_HNUMBER: '#invoice_hnumber',
            INVOICE_COMPANY_LNUMBER: '#invoice_lnumber',
            INVOICE_COMPANY_POSTAL_CODE: '#invoice_postal',
            INVOICE_EMAIL: '#invoice_email',
            INVOICE_PHONE: '#invoice_phone',
            INVOICE_COMPANY_CITY: '#invoice_city',
            INVOICE_CONTRACTOR_NUMBER: '#invoice_contractor_number'
          },
          FORM_FIELDS_LABEL : '.label-invoice-field',
          FORM_FIELDS_LABEL_STAR : '.label-invoice-field > .label-star',
          SPECIAL_INVOICE_FIELDS_CONTAINER : '.step-2-extra-fields-for-invoice',
          SUBSECTION_INCORRECT_CONTRACTOR_DATA : '.subsection-btn-wrong-invoice-data',
          BTN_REPORT_INCORRECT_CONTRACTOR_DATA : '.btn-report-incorrect-contractor-data',
          SUBSECTION_COPY_DATA_FROM_DELIVERY_TO_INVOICE : '.subsection-copy-data-from-delivery-to-invoice'
    },
    DEPARTMENTS: {
        CHANGE_BTN:                '#personal-departments-button',
        SUBMIT_BTN:                '#personal-department-submit',
        MODAL_SELECT:              '#personal-department-select',
        MODAL:                     '#DepartmentsModal',
        ADDRESS:                   '#personal-department-address',
        ADDRESS_DIV:               '#personal-department-contener',
        ADDRESS_DIV_ERROR_VALIDATE: '#cart_delivery_department_id-error',
        ID_INPUT:                  '#cart_delivery_department_id',
        MAP_VOIVODESHIP:           '#svg_poland_map a',
        MAP_VOIVODESHIP_LIST:      '#department-map-list',
        MAP_VOIVODESHIP_LIST_ELEM: '#department-map-list .map-list-element',
    },
    DPD : {
      MODAL : '#DpdMapModal',
      MODAL_BODY : '#dpd-map-modal-body',
      IFRAME : '#dpd-map-iframe',
    },
    EXTERNAL_DELIVERY : {
        ID_INPUT : '#cart_delivery_external_id',
        ID_INPUT_TYPE : '#cart_delivery_external_type',
        ADDRESS_DIV: '#external-delivery-points',
        ADDRESS: '#external-delivery-address',
        CHANGE_BTN: '#external-delivery-button',
    }
};
export const Step2Selectors = {
    // I didn't know how to properly name these Selectors, so I just put "common". By this name I meant
    // the rest of the selectors that couldn't be grouped
    COMMON:               {
        FORM:                                  '#step2_form',
        MODAL_FORM:                            '#step2modalForm',
        GUEST_MODAL:                            '#GuestModal',
        NEW_ACCOUNT_MODAL:                      '#NewAcccountModal',
        BTN_CREATE_NEW_ACCOUNT_AND_CONTINUE: '.btnStep2CreateAccountAndContinue',
        CREDIT_BANK_MODAL:                    '#CreditBankModal',
        MODAL_EMAIL:                           '#step2-modal-email',
        MODAL_FORM_SERIALIZED:                 '#cart-form-serialized',
        CREDIT_PAYMENT_MODAL:					'#CreditPaymentModal',
		    CREDIT_PAYMENT_MODAL_BTN_ACCEPT: 		'.btn-accept-credit-payment-method-full-cost',
        DELIVERY:                              '#delivery',
        DELIVERY_EMAIL_INPUT:                  '#delivery_email',
        PAYMENT:                               '#payment',
        CONTINUE_AS_GUEST_BTN:                 '.continueAsGuest',
        LOGIN_WHEN_USER_IS_GUEST_BTN:          '#login-when-user-is-guest',
        LAST_STEP_BTN:                         '#lastStepButton',
        LAST_STEP_BTN_FINAL:                   '#lastStepButtonFinal',
        ALLOW_GUEST_CHECKER:                   '#allowGuestContinue',
        SAVED_DELIVERY:                        '#cart_saved_delivery',
        WANT_NEW_ACCOUNT_CHECKBOX:             '#want_new_account',
        WANT_INVOICE_CHECKBOX:                 '#want_invoice',
        CREATE_NEW_ACCOUNT_PASSWORD:           '#create_account_repeat_password',
        SECRET_FIELD_NEW_PASSWORD: 				'#newPassword',
        WANT_ANOTHER_DELIVERY_ADRESS_CHECKBOX: '#want_another_delivery_address',
        COPY_INVOICE_BTN:                      '#step2-copy-invoice',
        COPY_ANOTHER_DELIVERY_ADRESSES_BTN:    '#step2-copy-another_delivery',
        INVOICE_DATA:                          '#invoice-data',
        DELIVERY_TILE:                         '.method-delivery',
        DELIVERY_TILE_SALON:                   '#delivery_method_19',
        DELIVERY_TILE_KURIER:                   '#delivery_method_20',
        DELIVERY_TILE_OWN_TRANSPORT:            '#delivery_method_21',
        DELIVERY_TILE_DPD_PACKMACHINE:               '#delivery_method_22',
        DELIVERY_TILE_DPD_POINT:                     '#delivery_method_23',
        // No, these are not new radio stations. They're just an inputs with type radio
        DELIVERY_RADIO:                        '#delivery .delivery_method_radio',
        SELECTED_DELIVERY_RADIO:               '#delivery .delivery_method_radio:checked',
        DELIVERY_RADIO_SALON:                  '#cart_delivery_method_19',
        DELIVERY_RADIO_KURIER:                 '#cart_delivery_method_20',
        DELIVERY_RADIO_OWN_TRANSPORT:           '#cart_delivery_method_21',
        DELIVERY_RADIO_DPD_PACKMACHINE:         '#cart_delivery_method_22',
        DELIVERY_RADIO_DPD_POINT:               '#cart_delivery_method_23',
        SELECTED_PAYMENT_RADIO:					'#payment .payment_method_radio:checked',
        DELIVERY_RADIO_IS_CREDIT:				'payment_method_radio_is_credit',
        PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_3_0_10:	'#cart_payment_method_13',
        PAYMENT_METHOD_CREDIT_AGRICOLE_LOAN_0_20:	'#cart_payment_method_12',
        PAYMENT_METHOD_ERATY:                  '#cart_payment_method_10',
        PAYMENT_METHOD_PRZELEWY:               '#cart_payment_method_8',
        PAYMENT_METHOD_COD:                    '#cart_payment_method_6',
        PAYMENT_TILE_COD:                      '#payment_method_6',
        PAYMENT_TILE_ERATY:                    '#payment_method_10',
        PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_3_0_10:	'#payment_method_13',
        PAYMENT_TILE_CREDIT_AGRICOLE_LOAN_0_20:		'#payment_method_12',
        CREDIT_AGRICOLE_CALCULATOR_BTN:			'.js-btn-ca-calculator',
        CREDIT_AGRICOLE_PAYMENT_TEXT_AVAILABLE:		'.js-payment-ca-text-available',
        CREDIT_AGRICOLE_PAYMENT_TEXT_UNAVAILABLE:	'.js-payment-ca-text-unavailable',
        PAYMENT_ERROR_CREDIT_AGRICOLE_MAX_LIMIT:	'.payment_method_error_credit_agricole_max_limit',
        PAYMENT_ERROR_CREDIT_AGRICOLE_INVOICE:		'.payment_method_error_credit_agricole_invoice',
        PAYMENT_INFO_CREDIT_AGRICOLE_WARNING:		'.payment_method_info_credit_agricole_warning',
        PAYMENT_INFO_CREDIT_AGRICOLE_LINK_PDF:		'.payment_method_info_credit_agricole_link_pdf',
        ANOTHER_DELIVERY_ADDRESS_DATA:         '#another-delivery-address-data',
        LIGHT_PRELOADER:                       '#light-preloader',
        SUMMARY_BASKET_PRICE:					'#summary-delivery-price',
        CART_THRESHOLD: {
            INPUT_IS_ACTIVE : '#cartThresholdIsdActive',
            INPUT_IS_FIRST_THRESHOLD_CROSSED : '#cartThresholdIsFirstThresholdIsCrossed'
		    }
    },
    DELIVERY_FORM_FIELDS: {
        CART_SAVED_DELIVERY: '#cart_saved_delivery',
        DELIVERY_FIRST_NAME: '#delivery_first_name',
        DELIVERY_LAST_NAME:  '#delivery_last_name',
        DELIVERY_STREET:     '#delivery_street',
        DELIVERY_HNUMBER:    '#delivery_hnumber',
        DELIVERY_LNUMBER:    '#delivery_lnumber',
        DELIVERY_POSTAL:     '#delivery_postal',
        DELIVERY_CITY:       '#delivery_city',
        DELIVERY_PHONE:      '#delivery_phone',
    },
    FORM_FIELDS_ERROR:    {
        ID_INPUT: '#delivery_department_id-error',
    },
    INVOICE: {
        SECTION: '#invoice-section-data',
        BTN_SEARCH_CONTRACTOR:	'.btn-find-contractor-by-nip',
        FIELD_NIP: '#invoice_nip',
        FIELD_NIP_ERROR: '#invoice_nip_error',
        CONTRACTORS_LIST : {
            SECTION : '#invoice-contractors-list',
            SELECTED_CONTRACTOR_ITEM : '#invoice-contractors-selected-contractor',
            SELECTED_CONTRACTOR_ITEM_BTN : '.btn-invoice-contractors-selected-contractor',
            SELECTED_CONTRACTOR_ITEM_TEXT_FIRST_ROW : '.invoice-contractors-selected-contractor-text-first-row',
            SELECTED_CONTRACTOR_ITEM_TEXT_SECOND_ROW : '.invoice-contractors-selected-contractor-text-second-row',
            TEMPLATE_ELEMENT : '#invoice-contractors-item-template',
            LIST_CONTAINER : '#invoice-contractors-list-container',
            LIST_CONTAINER_SORTABLE_MODE : '.contractors-list-sortable',
            SINGLE_CONTRACTOR_ROW : '.invoice-contractor-item',
            SINGLE_CONTRACTOR_RADIO_BUTTON : '.invoice-contractor-item-btn',
            SINGLE_CONTRACTOR_LABEL : '.invoice-contractor-item-label',
            SINGLE_CONTRACTOR_TEXTS : '.invoice-contractors-item-texts',
            SINGLE_CONTRACTOR_TEXT_FIRST_LINE : '.invoice-contractors-item-text-first-line',
            SINGLE_CONTRACTOR_TEXT_SECOND_LINE : '.invoice-contractors-item-text-second-line',
		    },
        FORM_SECTION : '#invoice-data-fields',
        FORM_FIELDS : {
            INVOICE_COMPANY_NAME: '#invoice_company_name',
            INVOICE_COMPANY_STREET: '#invoice_street',
            INVOICE_COMPANY_HNUMBER: '#invoice_hnumber',
            INVOICE_COMPANY_LNUMBER: '#invoice_lnumber',
            INVOICE_COMPANY_POSTAL_CODE: '#invoice_postal',
            INVOICE_EMAIL: '#invoice_email',
            INVOICE_PHONE: '#invoice_phone',
            INVOICE_COMPANY_CITY: '#invoice_city',
            INVOICE_CONTRACTOR_NUMBER: '#invoice_contractor_number'
          },
          FORM_FIELDS_LABEL : '.label-invoice-field',
          FORM_FIELDS_LABEL_STAR : '.label-invoice-field > .label-star',
          SPECIAL_INVOICE_FIELDS_CONTAINER : '.step-2-extra-fields-for-invoice',
          SUBSECTION_INCORRECT_CONTRACTOR_DATA : '.subsection-btn-wrong-invoice-data',
          BTN_REPORT_INCORRECT_CONTRACTOR_DATA : '.btn-report-incorrect-contractor-data',
          SUBSECTION_COPY_DATA_FROM_DELIVERY_TO_INVOICE : '.subsection-copy-data-from-delivery-to-invoice'
    },
    DEPARTMENTS: {
        CHANGE_BTN:                '#personal-departments-button',
        SUBMIT_BTN:                '#personal-department-submit',
        MODAL_SELECT:              '#personal-department-select',
        MODAL:                     '#DepartmentsModal',
        ADDRESS:                   '#personal-department-address',
        ADDRESS_DIV:               '#personal-department-contener',
        ADDRESS_DIV_ERROR_VALIDATE: '#cart_delivery_department_id-error',
        ID_INPUT:                  '#cart_delivery_department_id',
        MAP_VOIVODESHIP:           '#svg_poland_map a',
        MAP_VOIVODESHIP_LIST:      '#department-map-list',
        MAP_VOIVODESHIP_LIST_ELEM: '#department-map-list .map-list-element',
    },
    DPD : {
      MODAL : '#DpdMapModal',
      MODAL_BODY : '#dpd-map-modal-body',
      IFRAME : '#dpd-map-iframe',
    },
    EXTERNAL_DELIVERY : {
        ID_INPUT : '#cart_delivery_external_id',
        ID_INPUT_TYPE : '#cart_delivery_external_type',
        ADDRESS_DIV: '#external-delivery-points',
        ADDRESS: '#external-delivery-address',
        CHANGE_BTN: '#external-delivery-button',
    }
};
